import { FC } from 'react';
import { Link } from 'react-router-dom';

import { appGeneratePath } from '@/shared/lib';

type Props = {
  conversationId: number;
};

/** Ссылка на карточку коммуникации, в которую загружено обращение HelpDeskEddy. */
export const C2EddyConversationLink: FC<Props> = ({ conversationId }) => (
  <Link
    to={appGeneratePath('/dialogs/:id?', { id: String(conversationId) })}
    className="text-primary text-sm underline hover:text-primary/80"
  >
    {conversationId}
  </Link>
);
